import { AlertTitle } from "@mui/material";
import { DefaultAlert } from "./Messages";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { createForm } from "@/hooks/form/source-data/useForm";
import { AppSettings } from "@/AppSettings";
import { FC, PropsWithChildren } from "react";
import { createEvent } from "@/hooks/form/source-data/useEvent";
import { ConfigurationStatus, Participant } from "@/api/dtos";
import ExcludedParticipantAlert from "./ExcludedParticipantAlert";
import ExcludedEventAlert from "./ExcludedEventAlert";
import ExcludedFormAlert from "./ExcludedFormAlert";

interface IExcludedAlertProps extends PropsWithChildren {
    participant?: Participant | undefined;
    event?: ReturnType<typeof createEvent>;
    form?: ReturnType<typeof createForm>;
}

const ExcludedAlert: FC<IExcludedAlertProps> = ({ 
    participant,
    event,
    form,
    children
}) => {
    if (participant?.status === ConfigurationStatus.Disabled) {
        return <ExcludedParticipantAlert participant={participant} />
    }

    if (event?.excluded) {
        return <ExcludedEventAlert event={event} />
    }

    if (form?.excluded) {
        return <ExcludedFormAlert form={form} />
    }

    return children ? <>{children}</> : null;
}

export default ExcludedAlert;